import React from 'react';
import PageWrapper from '../../components/UI/PageWrapper';
import TeamsList from '../../components/Admin/TeamsList';

const TeamsListPage = () => (
  <PageWrapper>
    <TeamsList />
  </PageWrapper>
);

export default TeamsListPage;

